// Typelizer digest 5a757d9b7cfaa71140c70b9784941324
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /learners/relief_listings/applications */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/relief_listings/applications', {}, options),
    method: 'post',
  }),

  /** GET /learners/relief_listings/applications/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/relief_listings/applications/new', {}, options),
    method: 'get',
  }),

  /** GET /learners/relief_listings/applications/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/relief_listings/applications/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /learners/relief_listings/applications/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/relief_listings/applications/:id', params, options),
    method: 'get',
  }),

  /** PATCH /learners/relief_listings/applications/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/relief_listings/applications/:id', params, options),
    method: 'patch',
  }),
}
